// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StoreCheckoutPageContainer from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutPageContainer";
import React from "react";

const OrderDetailsContainer: React.FC<WidgetProps> = ({ id }) => {
    return <StoreCheckoutPageContainer id={id} />;
};

const widgetModule: WidgetModule = {
    component: OrderDetailsContainer,
    definition: {
        group: "Order Details",
        displayName: "Order Details Container",
        allowedContexts: ["OrderDetailsPage", "OrderApprovalDetailsPage"],
    },
};

export default widgetModule;
